const PageNotFound = () => {
    return (<div className="w-full h-80 py-5 flex justify-center items-center">
        <h1 className="text-xl mx-3">Error 404: Page Not Found</h1>
    </div>);
}
 
export default PageNotFound;